import { Stack, styled } from '@mui/material';

import { CSSProperties } from 'react';

export const StatusWrapper = styled(Stack)(() => ({
  '&:focus-visible': {
    boxShadow: 'none',
  },
  alignItems: 'flex-end',
  backgroundColor: 'var(--color-grey-lighter)',
  borderRadius: 'var(--border-radius-small)',
  outline: 'none',
  padding: 'var(--spacing-medium)',
}));

export const WrapperRootStyles: CSSProperties = {
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'center',
};
